import { Serializable } from '@/models/core/serializable';
import { SchoolClass } from '@/models/school-class/school-class';
export class LgateDeleteStudentInfo implements Serializable<LgateDeleteStudentInfo> {
  studentNumber: string;
  schoolClass:   SchoolClass;
  manageNumber:  string;
  lastName:      string;
  firstName:     string;
  lastNameKana:  string;
  firstNameKana: string;

  deserialize(input: any) {
    this.studentNumber = input.studentNumber;
    this.schoolClass = new SchoolClass().deserialize(input.schoolClass);
    this.manageNumber = input.manageNumber;
    this.lastName = input.lastName;
    this.firstName = input.firstName;
    this.lastNameKana = input.lastNameKana;
    this.firstNameKana = input.firstNameKana;

    return this;
  }

  get fullName(): string {
    return this.lastName + " " + this.firstName;
  }
  get fullNameKana(): string {
    return this.lastNameKana + " " + this.firstNameKana;
  }
}

